import { combineStateReducer } from "../utils/combineStateReducer";
import { State, Selector } from "./types";

import * as editProjectReportTemplate from "./editProjectReportTemplate";
import * as retrieveProjectReport from "./retrieveProjectReport";
import * as retrieveProjectReports from "./retrieveProjectReports";
import * as retrieveProjectReportTemplate from "./retrieveProjectReportTemplate";
import * as submitProjectReport from "./submitProjectReport";
import * as removeProjectReport from "./removeProjectReport";
import * as editProjectReport from "./editProjectReport";

const initialState: State = {
  editProjectReportTemplate: editProjectReportTemplate.initialState,
  retrieveProjectReport: retrieveProjectReport.initialState,
  retrieveProjectReports: retrieveProjectReports.initialState,
  retrieveProjectReportTemplate: retrieveProjectReportTemplate.initialState,
  submitProjectReport: submitProjectReport.initialState,
  removeProjectReport: removeProjectReport.initialState,
  editProjectReport: editProjectReport.initialState,
};

const reduceState = combineStateReducer(initialState, {
  editProjectReportTemplate: editProjectReportTemplate.reduceState,
  retrieveProjectReport: retrieveProjectReport.reduceState,
  retrieveProjectReports: retrieveProjectReports.reduceState,
  retrieveProjectReportTemplate: retrieveProjectReportTemplate.reduceState,
  submitProjectReport: submitProjectReport.reduceState,
  removeProjectReport: removeProjectReport.reduceState,
  editProjectReport: editProjectReport.reduceState,
});

function createSelector(getState: () => State): Selector {
  return {
    ...editProjectReportTemplate.createSelector(
      () => getState().editProjectReportTemplate,
    ),
    ...retrieveProjectReport.createSelector(
      () => getState().retrieveProjectReport,
    ),
    ...retrieveProjectReports.createSelector(
      () => getState().retrieveProjectReports,
    ),
    ...retrieveProjectReportTemplate.createSelector(
      () => getState().retrieveProjectReportTemplate,
    ),
    ...submitProjectReport.createSelector(() => getState().submitProjectReport),
    ...removeProjectReport.createSelector(() => getState().removeProjectReport),
    ...editProjectReport.createSelector(() => getState().editProjectReport),
  };
}

export type { State, Selector };

export { reduceState, initialState, createSelector };
